import { Button } from 'antd';
import React from 'react';
import { CloseXS } from '../assets';

export const CustomModal = ({
    children,
    className,
    onCancel,
    open,
    title,
    uniqueClass,
    styles = {},
}) => {
    return (
        <>
            {open ? (
                <div className="ant-modal-root">
                    <div className="ant-modal-mask"></div>
                    <div className="ant-modal-wrap">
                        <div
                            className={`ant-modal ${
                                className ? className : ''
                            }`}
                        >
                            <div
                                className={`ant-modal-content ${uniqueClass}`}
                                style={styles}
                            >
                                <div
                                    className={`d-flex ${
                                        title
                                            ? 'justify-content-between align-items-center'
                                            : 'justify-content-end'
                                    }`}
                                >
                                    {title && title}
                                    <Button
                                        aria-label="Close"
                                        className="ant-modal-close"
                                        onClick={onCancel}
                                    >
                                        <span className="ant-modal-close-x">
                                            <CloseXS
                                                role="img"
                                                aria-label="close"
                                            />
                                        </span>
                                    </Button>
                                </div>
                                <div className="ant-modal-body">{children}</div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
};
